import http from "@/utils/http";


export const TimeRuleApi = {
  //获取简单列表（全部规则）
  querySimpleList(){
    return http.get(`/nexus/acsTimeRule/querySimpleList` )
  },
  getRegulationPage(queryForm) {
    return http.get("/nexus/acsTimeRule/page", queryForm)
  },
  regulationSave(acsTimeRuleForm) {
    return http.post("/nexus/acsTimeRule/save", acsTimeRuleForm)
  },
  getById (id) {
    return http.get(`/nexus/acsTimeRule/query/${id}` )
  },
  deleteById(id){
    return http.get(`/nexus/acsTimeRule/delete/${id}` )
  },
  getRegulationUserRuleInfo(ruleId){
    return http.get(`/nexus/acsTimeRule/queryUserRuleInfo/${ruleId}`)
  }
}
